import { cn } from "@/lib/utils";
import logoAtlas from "@/assets/logo-atlas.png";

interface AtlasAvatarProps {
  size?: "sm" | "md" | "lg";
  className?: string;
}

export function AtlasAvatar({ size = "md", className }: AtlasAvatarProps) {
  const sizeClasses = {
    sm: "w-6 h-6",
    md: "w-8 h-8",
    lg: "w-10 h-10",
  };

  return (
    <img
      src={logoAtlas}
      alt="System Atlas assistant logo"
      className={cn(sizeClasses[size], className)}
    />
  );
}
